export enum JobStatuses {
  SUCCEEDED = 'Succeeded',
  FAILED = 'Failed',
  DELETED = 'Deleted',
  ENQUEUED = 'Enqueued',
  SCHEDULED = 'Scheduled',
  AWAITING = 'Awaiting',
  PROCESSING = 'Processing',
}
